import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import * as branch from 'branch-sdk';
import Button from '../../components/button';
import {SM_URL, BRANCH_IO_KEY, BRANCH_IO_ENV} from '../../utils';
import './index.css';

function MobileRedirect ( { forceWebDisplay } ) {

	const {t} = useTranslation();

	useEffect(() => {
		branch.init(BRANCH_IO_KEY, function(err, data) {
			console.log('branch', err, data);
		});
	}, []);

	const goToMobileApp = () => {
		//window.location.href = 'https://gmailsharedcontacts.app.link';
		let linkData = null;

		if(window.location.pathname.includes('/label/')){

			let labelId = window.location.pathname.split('/label/')[1];

			linkData = {
				alias: `${BRANCH_IO_ENV}_shared_label_${labelId}`,
				data: {
					"$deeplink_path": `LabelContacts/true/${labelId}`,
					"route": "LabelContacts",
					"fromDeeplink": true,
					"labelId": labelId
				},
			};

		} else if (window.location.pathname.includes('/contact/')) {

			let contactId = window.location.pathname.split('/contact/')[1];

			linkData = {
				alias: `${BRANCH_IO_ENV}_shared_contact_${contactId}`,
				data: {
					"$deeplink_path": `ViewContact/true/${contactId}`,
					"route": "ViewContacts",
					"fromDeeplink": true,
					"contactGoogleId": contactId
				},
			};
		}

		branch.link(linkData, function(err, link) {
			console.log('branch', err, link);

			if(!err){
				window.location.href = link;
			}
		});


	};

	const goToSM = () => {
		window.open(SM_URL, '_blank');
	};

	const goToWeb = () => {
		forceWebDisplay()
	};

	return (
		<div className="mobile-redirect container">
			<div className="mobile-redirect__top">
				<img className="mb-3" src={`/img/scg_logo.png`} alt={t('textGscTitle')}/>
				<div className="mb-4">
					<h2 className="mb-4">{t('welcomeToApp')}</h2>
					<p className="mb-4">
						{t('mobileRedirectText')}
					</p>
					<Button onClick={goToMobileApp} className="btn-outline-primary">{t('mobileRedirectGoToMobileAppBtn')}</Button>
				</div>
			</div>
			<div className="mobile-redirect__bottom">
				<Button onClick={goToSM} className="btn-outline-primary mb-2">{t('mobileRedirectGoToSMBtn')}</Button>
				<Button onClick={goToWeb} className="btn-link font-weight-normal">{t('mobileRedirectGoToWebBtn')}</Button>
			</div>

		</div>
	)
}

export default MobileRedirect;
